// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Lm","floatingBox":"e_Mm","floatingAd":"e_Nm"};